import React from "react";

import type { TimeSeries } from "../../TimeSeriesChart/time-series";

export interface PaginationProps {
	pages: ReadonlyArray<ReadonlyArray<TimeSeries>>;
	index: number;
	onIndexChange: (index: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ index, pages, onIndexChange }) => (
	<div className="flex select-none justify-end gap-x-4">
		{index > 0 ? (
			<button className="link link-primary" onClick={() => onIndexChange(index - 1)} type="button">
				View previous {pages.at(index - 1)?.length}
			</button>
		) : (
			<span>Viewing first {pages.at(0)?.length} time series</span>
		)}

		<span className="border-0 border-grey-400 border-l border-solid" />

		{index < pages.length - 1 ? (
			<button className="link link-primary" onClick={() => onIndexChange(index + 1)} type="button">
				View next {pages.at(index + 1)?.length}
			</button>
		) : (
			<span>Viewing last {pages.at(-1)?.length} time series</span>
		)}
	</div>
);
